<template>
  <div :class="className" :style="{height: height,width: width}" />
</template>
<script>

import * as echarts from 'echarts'
require('echarts/theme/macarons')
import resize from '@/mixins/resize'

export default {
  components: {},
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '19rem'
    },
    colorData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getLineData(data, date) {
      
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions()
    },
    setOptions({ expectedData, actualData } = {}) {
      this.chart.setOption({
        title: {
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          backgroundColor: '#fff',
          borderWidth: '1',
          borderColor: 'grey',
          textStyle: {
            color: 'black'
          },
          color: 'black',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: '3%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          axisLabel: {
            formatter: '{value}%',
            color: '#696765'
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: 'dotted',
              // color: '#FCD973',
              color: '#696765',
              width: 2
            }
          },
          splitArea: {
            show: false
          }
        },
        yAxis: [{
          type: 'value',
          scale: true,
          axisLabel: {
            formatter: '{value}%',
            color: '#696765'
          },
          min: -100,
          max: 100,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        }],
        color: '#3A5B9A',
        series: [{
          name: '',
          type: 'scatter',
          symbolSize: 20,
          // symbolSize: 65,
          emphasis: {
            // focus: 'self'
          },
          data: [
            [3, -60, '产品尺码'],
            [2, -20, '产品做工'],
            [5, 30, '价格与促销'],
            [9, 40, '购物体验'],
            [12, 30, '顾客粘性'],
            [4, 70, '产品包装'],
            [3, 100, '售后服务'],
            [65, 30, '产品设计'],

            // [15, 40, '购物'],
            // [20, 50, '体验'],
            // [40, 50, '价格'],
            // [40, 90, '店铺'],
            // [50, 50, '加购'],
            // [50, -50, '未购'],
            // [60, -50, '产品'],
            // [20, -50, '包装'],
            // [70, 50, '售后'],
            // [30, -50, '类目'],
            // [30, 90, '营销'],
            // [30, 50, '品牌'],
            // [80, 50, '促销'],

            // [13, -30, 'Japn'],
            // [22, -30, 'Iceland'],
            // [35, 40, 'Canada'],
            // [29, 20, 'France'],
            // [35, 80, 'Australia'],
            // [80, 90, 'Norway'],
            // [50, 90, 'ingdom'],
            // [25, 70, 'Zealand'],
            // [25, 40, 'States'],
            // [28, -30, 'Finland'],
            // [35, -20, 'Cuba'],
            // [40, -40, 'Korea'],
            // [20, 90, 'Poland'],
            // [40, -30, 'Russia'],
            // [10, 90, 'China'],
            // [60, 70, 'North'],
            // [70, 10, 'Korea'],
            // [92, 80, 'Turkey'],
            // [90, 20, 'United'],
            // [45, 15, 'Zealand'],
            // [55, 50, 'Korea'],

            // [73, -20, 'Japn'],
            // [82, -40, 'Iceland'],
            // [95, 50, 'Canada'],
            // [75, 90, 'France'],
            // [35, 80, 'Australia'],
            // [60, 30, 'Norway'],
            // [65, 95, 'United'],
            // [85, 70, 'Zealand'],
            // [55, 20, 'States'],
            // [78, -60, 'Finland'],
            // [75, -60, 'Cuba'],
            // [80, -60, 'Korea'],
            // [90, 50, 'Poland'],
            // [80, -60, 'Russia'],
            // [90, 95, 'China'],
            // [60, 90, 'North'],
            // [60, -90, 'Korea'],
            // [92, 80, 'Turkey'],
            // [40, 70, 'United'],
            // [55, 95, 'Zealand'],
            // [65, 26, 'Korea'],
          ],
          labelLine: {
            show: true,
            length2: 5,
            lineStyle: {
              color: '#bbb'
            }
          },
          // markArea: {
          //   silent: false,
          //   itemStyle:{
          //     color: 'rgba(187, 198, 217, 0.4)'
          //   },
          //   data: [
          //     [{
          //       name: '',
          //       xAxis: 40
          //     },
          //     {
          //       name: '',
          //       xAxis: 90
          //     }]
          //   ],
          // },
          label: {
            show: true,
            formatter: function (param) {
              return param.data[2]
            },
            position: 'top',
            // position: 'inside',
            minMargin: 2,
            // fontSize: 14
          }
        }]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/voc/wordmouth/components/PointChart.vue